// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dvOrdinate,.msgClass .el-message__content{font-size:1.04167vw}.dvOrdinate{width:13vw;text-align:center}", ""]);
// Exports
module.exports = exports;
